import React from 'react';
import { useContent } from '../content/ContentContext';
import { Reveal, SectionHeader } from '../lib/ui';

const Team: React.FC = () => {
  const { team } = useContent();
  if (!team.visible) return null;

  return (
    <section id="team" className="scroll-mt-20 border-t border-line py-24 md:py-32">
      <div className="container-site">
        <div className="grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHeader eyebrow={team.eyebrow} title={team.title} intro={team.intro} />
          </div>
          <ul className="grid gap-5 sm:grid-cols-2 lg:col-span-7">
            {team.members.map((m, i) => (
              <li key={m.name}>
                <Reveal delay={i * 0.08}>
                  <div className="card card-hover h-full p-6 sm:p-7">
                    <div className="mb-6 h-28 w-28 overflow-hidden rounded-full border border-white/10 bg-surface-2 sm:h-32 sm:w-32">
                      <img src={m.image} alt={m.name} className="h-full w-full object-cover" loading="lazy" />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold tracking-tight">{m.name}</h3>
                      <p className="text-sm text-accent">{m.role}</p>
                      <p className="mt-2 text-[15px] text-fg-2">{m.focus}</p>
                      {m.email && (
                        <a href={`mailto:${m.email}`} className="mt-3 inline-block text-sm text-fg-3 hover:text-fg">{m.email}</a>
                      )}
                    </div>
                  </div>
                </Reveal>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Team;
